module.exports = __webpack_public_path__ + "img/guide2.5beaec10.png";